import { Skeleton, Stack, Paper, Group, Box, Divider } from 'components'

/**
 * Apple-style skeleton for Edit Project page (Arc Mosaico)
 * Mirrors the actual form structure with realistic proportions
 */
export const EditProjectSkeleton = () => (
  <Stack spacing="lg">
    {/* Back link */}
    <Skeleton height={18} width={140} radius="sm" />

    {/* Title */}
    <Skeleton height={36} width={180} radius="md" />

    {/* Stepper */}
    <Group spacing={16} noWrap>
      <Group spacing="md" noWrap>
        <Skeleton height={32} width={32} radius="xl" />
        <Skeleton height={18} width={110} radius="sm" />
      </Group>
      <Skeleton height={2} width={100} />
      <Group spacing="md" noWrap>
        <Skeleton height={32} width={32} radius="xl" />
        <Skeleton height={18} width={140} radius="sm" />
      </Group>
    </Group>

    {/* Form Paper */}
    <Paper shadow="sm" p="lg" radius="md" withBorder>
      <Stack spacing="xl">
        {/* Required fields indicator */}
        <Skeleton height={14} width={200} radius="sm" sx={{ opacity: 0.6 }} />

        {/* Grade Level */}
        <FormFieldSkeleton
          labelWidth={280}
          descriptionWidth={320}
          inputHeight={42}
        />

        {/* Project Name */}
        <FormFieldSkeleton
          labelWidth={240}
          descriptionWidth={380}
          inputHeight={42}
        />

        {/* Essential Question */}
        <FormFieldSkeleton
          labelWidth={260}
          descriptionWidth={420}
          inputHeight={80}
        />

        {/* Summary */}
        <FormFieldSkeleton
          labelWidth={220}
          descriptionWidth={300}
          inputHeight={140}
        />

        {/* Learning Goals */}
        <Stack spacing="md">
          <Box>
            <Skeleton height={20} width={480} radius="sm" mb={6} />
            <Skeleton height={16} width={520} radius="sm" />
          </Box>
          <Group noWrap>
            <Skeleton height={42} sx={{ flex: 1 }} radius="md" />
            <Skeleton height={42} width={80} radius="md" />
          </Group>
          {/* Existing goals */}
          <Stack spacing="xs">
            {[420, 360, 400, 320, 380].map((width, i) => (
              <Group key={i} position="apart" noWrap>
                <Skeleton height={48} sx={{ flex: 1 }} radius="md" />
              </Group>
            ))}
          </Stack>
        </Stack>

        <Divider />

        {/* Deliverable */}
        <FormFieldSkeleton
          labelWidth={200}
          descriptionWidth={350}
          inputHeight={120}
        />

        {/* Next Button */}
        <Group position="right" mt="md">
          <Skeleton height={46} width={100} radius="md" />
        </Group>
      </Stack>
    </Paper>
  </Stack>
)

/**
 * Reusable form field skeleton
 */
const FormFieldSkeleton = ({
  labelWidth,
  descriptionWidth,
  inputHeight,
}: {
  labelWidth: number
  descriptionWidth: number
  inputHeight: number
}) => (
  <Stack spacing="xs">
    <Skeleton height={20} width={labelWidth} radius="sm" />
    <Skeleton height={14} width={descriptionWidth} radius="sm" sx={{ opacity: 0.7 }} />
    <Skeleton height={inputHeight} radius="md" />
  </Stack>
)
